import { QueryClient } from '@tanstack/react-query'

/**
 * Single TanStack Query client for apps/ordo. Lives in its own module (not
 * main.tsx) so route loaders can prefetch into the same cache the hooks read.
 * Defaults:
 *   - `staleTime: 30_000` — list views feel snappy without re-fetching
 *     on every render but still pick up server changes within 30s.
 *   - `gcTime: 5 * 60_000` — keep cached responses around for 5 min so
 *     back-button navigations are instant.
 *   - `refetchOnWindowFocus: false` — most of the app is forms +
 *     dashboards where refetching on focus is more annoying than useful.
 *     Individual hooks can opt-in via `refetchOnWindowFocus: true` when
 *     real-time freshness matters (cafeteria-mode, billing-balance, etc.).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
})
